var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "gps 1",
    clipPath: "url(#clip0_5482_122503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5482_122503",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5482_122503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5482_122503",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path645",
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5482_122503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path651",
    d: "M12.0031 20.0508C7.55716 20.0508 3.95312 16.4467 3.95312 12.0008C3.95312 7.55494 7.55716 3.95086 12.0031 3.95086C16.449 3.95086 20.053 7.55494 20.053 12.0008C20.053 16.4467 16.449 20.0508 12.0031 20.0508Z",
    stroke: "",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path655",
    d: "M11.9998 15.3828C10.1316 15.3828 8.61719 13.8684 8.61719 12.0002C8.61719 10.1321 10.1316 8.61767 11.9998 8.61767C13.8679 8.61767 15.3824 10.1321 15.3824 12.0002C15.3824 13.8684 13.8679 15.3828 11.9998 15.3828Z",
    stroke: "",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path659",
    d: "M12 0.710875V3.95312",
    stroke: "",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path663",
    d: "M12 20.0507V23.293",
    stroke: "",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path667",
    d: "M0.707031 12H3.95036",
    stroke: "",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path671",
    d: "M20.0508 12H23.3068",
    stroke: "",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5482_122503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetIcon);
export default __webpack_public_path__ + "static/media/fleet_icon.f2de21e6dad7cae7e2eacc2672fb5b26.svg";
export { ForwardRef as ReactComponent };